<template>
  <v-main>
    <v-container fluid>
      <v-card :elevation="0">
        <v-card-title>
          <h2>Strategy Review</h2>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="strategies"
          :search="search"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 30, -1]
          }"
          :items-per-page="20"
          item-key="id"
          class="elevation-1"
          dense
          :loading="loading"
          loading-text="Loading... Please wait"
        >
          <template v-if="games !== []" v-slot:item="{ item }">
            <tr>  
              <td 
                :style="highlightUser(item, null)"
                class="text-left">
                {{ item.name }}
              </td>
              <td 
                :style="highlightUser(item, 'L')"
                class="text-center">
                {{ item.pearls }}
              </td>
              <td 
                :style="highlightUser(item, 'M')"
                class="text-center custom-highlight-column">
                {{ item.oysters }}
              </td>
              <td 
                :style="highlightUser(item, 'M')"
                class="text-center custom-highlight-column">
                {{ item.breadandbutter }}
              </td>
              <td 
                :style="highlightUser(item, 'R')"
                class="text-center custom-highlight-column">
                {{ item.whiteelephant }}
                </td>
            </tr>
          </template>


           <!-- <template v-if="games !== []" v-slot:item="{ item }">
            <tr>  
              <td :style="highlightUser(item.resultID)" class="text-left">{{ item.name }}</td>
              <td class="text-center custom-highlight-column">{{ item.pearls }}</td>
              <td class="text-center custom-highlight-column">{{ item.oysters }}</td>
              <td class="text-center custom-highlight-column">{{ item.breadandbutter }}</td>
              <td class="text-center custom-highlight-column">{{ item.whiteelephant }}</td>
            </tr>
          </template> -->

          <template slot="body.append">
            <!-- <tr style="color:#156243"> -->
              <tr class="pink--text">
              <th class="text-center title">Averages</th>
              <th class="text-center title">{{ avgField("pearls") }}</th>
              <th class="text-center title">{{ avgField("oysters") }}</th>
              <th class="text-center title">
                {{ avgField("breadandbutter") }}
              </th>
              <th class="text-center title">{{ avgField("whiteelephant") }}</th>
            </tr>
          </template>
        </v-data-table>
        <v-row v-if="advanceRoute" class="mr-2">
          <v-spacer></v-spacer>
          <v-btn :loading="false" color="#418F7B" text x-large @click="next"
            >Next</v-btn
          >
        </v-row>
        <v-row v-else class="mr-2">
          <v-spacer></v-spacer>
          <v-btn :disabled="true" color="#951B20" text>
            Please Wait For Game to advance
          </v-btn>
        </v-row>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import { usersCollection } from "@/main";

export default {
  data() {
    return {
      search: "",
      loading: false,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          class: "title"
        },
        {
          text: "Pearls",
          sortable: true,
          value: "pearls",
          class: "title",
          align: "center"
        },
        {
          text: "Oysters",
          sortable: true,
          value: "oysters",
          class: "title",
          align: "center"
        },
        {
          text: "Bread and Butter",
          sortable: true,
          value: "breadandbutter",
          class: "title",
          align: "center"
        },
        {
          text: "White Elephant",
          sortable: true,
          value: "whiteelephant",
          class: "title",
          align: "center"
        }
      ]
    };
  },
  computed: {
    games() {
      return this.$store.getters.games;
    },
    strategies() {
      if (this.$store.getters.groupPlay) {
        // const currentGameID = this.$store.getters.currentGameID;
        const currentGameID = this.$store.getters.userCurrentGameID;
        return this.$store.getters.allResults.filter(
        obj => obj.gameID === currentGameID);
      }
      const result = this.$store.getters.allResults.filter(obj => obj.oysters !== null);
      return result.sort((a, b) => {
            return b.timestamp - a.timestamp;
          })
    },
    advanceRoute() {
      return this.$store.getters.advanceRoute(this.$route.path);
    },
    resultID() {
      return this.$store.getters.resultID;
    }
  },
  methods: {
    next() {
      this.$router.push("portfolio");
    },
    // highlightUser(resultID) {
    //   if (resultID === this.resultID) {
    //     return { color: 'red', textWeight: 'bold', fontSize: '18px' };

    //     // return {borderLeft: "thick sold hsl(0, 100%, 50%)"};
    //   }
    // },
    highlightUser(x,y) {
      const left = (y === 'L' ? '4px solid grey' : '');
      if (x.resultID === this.resultID) {
        return {backgroundColor: '#E8E8E8', 
        color: '#951B20', 
        fontSize: '1.2em',
        fontWeight: 'bold',
        borderLeft: (y === 'L' ? '4px solid grey' : ''),
        borderRight: (y === 'R' ? '4px solid grey' : ''),
        };
      } else {
        return {backgroundColor: (y === 'M' | y === 'L' | y === 'R' ? '#F7F7F7' : 'transparent'), 
        color: (y === 'M' | y === 'L' | y === 'R' ? 'blue' : ''),
        fontWeight: (y === 'M' | y === 'L' | y === 'R' ? 'bold' : ''),
        borderLeft: (y === 'L' ? '4px solid grey' : ''),
        borderRight: (y === 'R' ? '4px solid grey' : ''),
        };
      }
    },
    highlightRow(resultID) {
      if (resultID === this.resultID) {
        return { outline: 'thin solid' };
      }
    },
    avgField(key) {
      const nonNull = this.strategies.filter(obj => obj[key] !== null);
      const avg =
        this.strategies.reduce((a, b) => a + (b[key] || 0), 0) / nonNull.length;
      return avg.toFixed(1);
    }
  }
};
</script>

<style>
tr.border{
  outline: thin solid;
}
</style>
